export const actionTypes = {
  REQUEST_START: 'PROPERTY_OBJECT_TYPES.OBJECT_TYPES.REQUEST_START',
  REQUEST_SUCCESS: 'PROPERTY_OBJECT_TYPES.OBJECT_TYPES.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'PROPERTY_OBJECT_TYPES.OBJECT_TYPES.REQUEST_FAILURE',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
